import { Megaphone } from 'lucide-react';

import { NodeShell } from './NodeShell';

import type { CampaignNodeData } from '@repo/shared-types';

export const CampaignNode = ({
  data,
  selected,
}: {
  data: CampaignNodeData;
  selected?: boolean;
}) => {
  const subtitle = [data.name || data.configurationId || null, data.channel ?? 'PSTN']
    .filter(Boolean)
    .join(' · ');

  return (
    <NodeShell
      type="campaign"
      icon={<Megaphone size={16} />}
      label={data.label}
      subtitle={subtitle || undefined}
      selected={selected}
    />
  );
};
